










































































import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Term, DefaultTerm, DefaultTermShort } from "#/model/master";
import RulesMixin from "#/mixins/rulesMixin";
import AiRecommendMixin from "@/components/recommend/mixin";

@Component
/**
 * AIお勧め検索 短期目標編集コンポーネント
 */
export default class FormShortTerm extends Mixins(
  RulesMixin,
  AiRecommendMixin
) {
  /** Prop */

  /** 編集対象の看護計画内容 */
  @Prop({ default: () => DefaultTerm() }) value!: Term;

  /** getter */

  /** 編集対象の看護計画内容 */
  private get Term(): Term {
    return this.value;
  }

  private set Term(newValue: Term) {
    this.input(newValue);
  }

  /** 関数 */

  /** 短期目標追加 */
  private add() {
    this.Term.term_shorts.push(DefaultTermShort());
  }

  /** 短期目標削除 */
  private async remove(index: number) {
    if (
      !(await this.$openConfirm(
        "短期目標を削除します。よろしいですか？\n※保存ボタンを押すまで反映はされません。"
      ))
    ) {
      return;
    }

    this.Term.term_shorts.splice(index, 1);
  }

  /** 1つ上に移動 */
  private up(index: number) {
    this.Term.term_shorts = [
      ...this.swapWithPrevious(this.Term.term_shorts, index),
    ];
  }

  /** 1つ下に移動 */
  private down(index: number) {
    this.Term.term_shorts = [
      ...this.swapWithNext(this.Term.term_shorts, index),
    ];
  }

  /** Emit */

  /** 値変更 */
  @Emit("input")
  private input(term: Term) {
    return term;
  }
}
